import React, { useState } from 'react';
import Input from '../Input';
import StatuteArticleModal from './StatuteArticleModal';

interface LegalRepresentativeSectionProps {
  formData: {
    hasRepresentative: boolean;
    repFirstName: string;
    repLastName: string;
    repBirthPlace: string;
    repBirthProvince: string;
    repBirthDate: string;
    repPosition: string;
    repMobile: string;
  };
  errors: Record<string, string>;
  onChange: (field: string, value: string | boolean) => void;
}

const LegalRepresentativeSection: React.FC<LegalRepresentativeSectionProps> = ({
  formData,
  errors,
  onChange
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <StatuteArticleModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />

      <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-sm ring-1 ring-black/5 dark:ring-white/10 p-6 sm:p-8">
        <div className="mb-6">
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
            IL RAPPRESENTANTE ALLA VITA ASSOCIATIVA È:
          </h3>
          <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4 mb-4">
            <p className="text-sm text-gray-700 dark:text-gray-300 mb-2">
              Ai sensi dell'art. 4.1.1 dello Statuto UNASCA{' '}
              <button
                type="button"
                onClick={() => setIsModalOpen(true)}
                className="text-primary-600 dark:text-primary-400 hover:underline font-medium cursor-pointer"
              >
                (leggi l'articolo completo)
              </button>
            </p>
            <p className="text-xs text-gray-600 dark:text-gray-400 italic">
              La delega di rappresentanza può essere rilasciata ai soci o familiari che prestano la loro opera
              nell'impresa stessa con rapporto di collaborazione coordinata e continuativa o nella forma di
              impresa familiare. <strong>Non può essere rilasciata ai dipendenti.</strong>
            </p>
          </div>
        <label className="flex items-center cursor-pointer">
          <input
            type="checkbox"
            checked={formData.hasRepresentative}
            onChange={(e) => onChange('hasRepresentative', e.target.checked)}
            className="w-5 h-5 rounded border-gray-300 text-primary-600 focus:ring-primary-500"
          />
          <span className="ml-2 text-sm font-medium text-gray-700 dark:text-gray-300">
            Il rappresentante alla vita associativa è una persona diversa dal rappresentante legale
          </span>
        </label>
      </div>

      {formData.hasRepresentative && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Input
            label="Nome *"
            type="text"
            value={formData.repFirstName}
            onChange={(e) => onChange('repFirstName', e.target.value)}
            error={errors.repFirstName}
            fullWidth
            required
          />

          <Input
            label="Cognome *"
            type="text"
            value={formData.repLastName}
            onChange={(e) => onChange('repLastName', e.target.value)}
            error={errors.repLastName}
            fullWidth
            required
          />

          <Input
            label="Nato a *"
            type="text"
            value={formData.repBirthPlace}
            onChange={(e) => onChange('repBirthPlace', e.target.value)}
            error={errors.repBirthPlace}
            fullWidth
            required
          />

          <Input
            label="Provincia * (es. RM)"
            type="text"
            value={formData.repBirthProvince}
            onChange={(e) => onChange('repBirthProvince', e.target.value.toUpperCase())}
            error={errors.repBirthProvince}
            maxLength={2}
            fullWidth
            required
          />

          <Input
            label="Data di nascita *"
            type="date"
            value={formData.repBirthDate}
            onChange={(e) => onChange('repBirthDate', e.target.value)}
            error={errors.repBirthDate}
            fullWidth
            required
          />

          <Input
            label="In qualità di * (es. Socio)"
            type="text"
            value={formData.repPosition}
            onChange={(e) => onChange('repPosition', e.target.value)}
            error={errors.repPosition}
            placeholder=""
            fullWidth
            required
          />

          <Input
            label="Cellulare"
            type="tel"
            value={formData.repMobile}
            onChange={(e) => onChange('repMobile', e.target.value)}
            error={errors.repMobile}
            fullWidth
          />
        </div>
      )}

      {!formData.hasRepresentative && (
        <p className="text-sm text-gray-600 dark:text-gray-400 italic">
          Attiva questa sezione se il rappresentante legale è diverso dal rappresentante alla vita associativa.
        </p>
      )}
    </div>
    </>
  );
};

export default LegalRepresentativeSection;

